module.exports = __webpack_public_path__ + "img/haikouLogo.1ab1999f.png";